<div class="component-content">
  @if (errorMessage) {
    <div class="snackbar snackbar-red justify-center">{{ errorMessage }}</div>
  }
  @if (successMessage) {
    <div class="snackbar snackbar-green justify-center">
      {{ successMessage }}
    </div>
  }
  <div class="page-title">
    <span class="font-medium-display-small text-center"> Passwort-Reset </span>
  </div>
  <form
    class="flex-c form-content"
    [formGroup]="resetPasswordForm"
    (ngSubmit)="resetPassword()">
    <div class="form-group">
      <label class="input-label" for="password">
        Passwort{{
          fieldRequired(resetPasswordForm.get('password')) ? '*' : ''
        }}
      </label>
      <div class="password-input-wrapper">
        <input
          [type]="showPassword ? 'text' : 'password'"
          class="form-control input-text"
          [class]="{
            'input-error':
              (resetPasswordForm.get('password').invalid &&
                resetPasswordForm.get('password').touched) ||
              passwordMismatch,
            'input-success':
              resetPasswordForm.get('password').valid &&
              resetPasswordForm.get('password').touched &&
              !passwordMismatch,
          }"
          id="password"
          formControlName="password"
          placeholder="Passwort"
          autocomplete="new-password" />
        <button
          type="button"
          class="password-toggle-button"
          (click)="togglePasswordVisibility()"
          [attr.aria-label]="
            showPassword ? 'Passwort verbergen' : 'Passwort anzeigen'
          ">
          <i
            [class]="
              showPassword ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'
            "></i>
        </button>
      </div>
      <!-- Error Messages -->
      <app-password-error
        [control]="resetPasswordForm.get('password')"></app-password-error>

      <label class="input-label" for="passwordCheck">
        Passwort wiederholen{{
          fieldRequired(resetPasswordForm.get('passwordCheck')) ? '*' : ''
        }}
      </label>
      <div class="password-input-wrapper">
        <input
          [type]="showPasswordCheck ? 'text' : 'password'"
          class="form-control input-text"
          [class]="{
            'input-error':
              resetPasswordForm.get('passwordCheck').invalid &&
              resetPasswordForm.get('passwordCheck').touched,
            'input-success':
              resetPasswordForm.get('passwordCheck').valid &&
              resetPasswordForm.get('passwordCheck').touched,
          }"
          id="passwordCheck"
          formControlName="passwordCheck"
          placeholder="Passwort wiederholen"
          autocomplete="new-password" />
        <button
          type="button"
          class="password-toggle-button"
          (click)="togglePasswordCheckVisibility()"
          [attr.aria-label]="
            showPasswordCheck ? 'Passwort verbergen' : 'Passwort anzeigen'
          ">
          <i
            [class]="
              showPasswordCheck
                ? 'fa-regular fa-eye-slash'
                : 'fa-regular fa-eye'
            "></i>
        </button>
      </div>
      <!-- Error Messages -->
      <app-password-error
        [control]="resetPasswordForm.get('passwordCheck')"></app-password-error>
    </div>
    <div class="form-button flex-c">
      <button type="submit" class="inwi-text-button-large-primary">
        Passwort zurücksetzen
      </button>
    </div>
  </form>
</div>
